import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import { IRemoveConfimationBoxProps, IRemoveConfimationBoxState } from '../../../../interfaces/IRemoveConfimationBox';

export default class RemoveConfimationBox extends React.Component<IRemoveConfimationBoxProps, IRemoveConfimationBoxState> {

    private _labelId: string = getId('dialogLabel');
    private _subTextId: string = getId('subTextLabel');

    constructor(props: IRemoveConfimationBoxProps) {
        super(props);
    }

    public render() {
        return (
            <div>
                <Dialog
                    hidden={this.props.hideDialog}
                    onDismiss={this.props._cancel}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: 'Artikel verwijderen?',
                        subText: 'Alle artikelgegevens worden permanent verwijderd'
                    }}
                    modalProps={{
                        titleAriaId: this._labelId,
                        subtitleAriaId: this._subTextId,
                        isBlocking: false,
                        styles: { main: { maxWidth: 450 } }
                    }}
                >
                    <DialogFooter>
                        <DefaultButton onClick={this.props._cancel} text="Nee" />
                        <PrimaryButton
                            onClick={() => this.props._removeItem(this.props.selectedItemKey, true)}
                            text="Ja" />
                    </DialogFooter>
                </Dialog>
            </div>
        );
    }
}
